import mixpanel from 'mixpanel-browser';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { PlayIcon } from '../../components/icons/PlayIcon';
import { useState } from 'react';
import { VideoPreviewModal } from '../EventLanding/Publish/VideoPreviews';

const DEMO_VIDEO_URL =
  'https://storage.googleapis.com/zync-media/zync-media/manual-uploads/Zync%20Solo%20Studio%20-%205%20min.mp4';

export const WelcomeDemoVideo = () => {
  const userId = useSelector((st) => st.auth?.user?.userId);
  const [showVideoModal, setShowVideoModal] = useState(false);

  return (
    <>
      {showVideoModal && (
        <VideoPreviewModal
          closeModal={() => setShowVideoModal(false)}
          selectedPlaybackUrl={DEMO_VIDEO_URL}
        />
      )}
      <div className="flex w-full h-[159px] md:h-[329px] justify-center items-center">
        <button
          className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-[#E75A4D] w-24 h-24 rounded-full justify-center items-center flex z-10"
          onClick={() => {
            mixpanel.track('Onboarding: Played Demo Video', {
              distinct_id: userId,
            });
            setShowVideoModal(true);
          }}
        >
          <PlayIcon color={'#FFFFFF'} width={45} height={45} />
        </button>
        <ReactPlayer
          url={
            'https://storage.googleapis.com/zync-media/zync-media/manual-uploads/Zync%20Solo%20Studio%20-%205%20min.mp4'
          }
          width="auto"
          height="100%"
          playing={false}
          controls={false}
          light={false}
          loop={false}
          volume={1}
          pip={false}
        ></ReactPlayer>
      </div>
    </>
  );
};
